import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LoginContext } from "context/Auth/LoginContext";
import usePost from "Hooks/usePost";
import { useTranslation } from "react-i18next";

const ExpiredSessionModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { setIsLoggedIn, setUser, setIsVerified, setToken, clearStorage } =
    useContext(LoginContext);

  const { postData, isLoading, isError, data } = usePost();

  const handleLogout = async () => {
    const response = await postData("auth/logout");
    if (response?.status === 200) {
      setIsLoggedIn(false);
      setUser(null);
      setIsVerified(false);
      setToken(null);
      clearStorage();
    }
  };

  const handleLogin = async () => {
    await handleLogout();
    navigate("/login");
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-8 rounded-lg max-w-md w-full mx-4">
        <h2 className="text-2xl font-bold mb-4 text-center text-red-600">
          {t("modals.expiredSession.title")}
        </h2>
        <p className="text-gray-600 mb-6 text-center">
          {t("modals.expiredSession.message")}
        </p>
        <div className="flex flex-col gap-4">
          <button
            onClick={handleLogin}
            className="bg-primary text-white py-2 px-4 rounded-md hover:bg-primary-dark transition-colors"
          >
            {t("modals.expiredSession.loginAgain")}
          </button>
          <button
            onClick={() => {
              handleLogout();
              onClose();
            }}
            className="border border-gray-300 py-2 px-4 rounded-md hover:bg-gray-100 transition-colors"
          >
            {t("modals.expiredSession.cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExpiredSessionModal;
